export const moneyWithComma = (number: number, digits: number): string => {
  if (!isNaN(number)) {
    return number.toFixed(digits).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
};

export const preventNonNumberChar = (event: React.KeyboardEvent<unknown>): void => {
  if (['-', '+', 'e'].includes(event.key)) event.preventDefault();
};
